<template>
  <div class="role-select-container">
    <div class="role-card">
      <h1 class="title">选择角色</h1>
      
      <!-- Role Selection Buttons -->
      <div class="role-buttons" v-if="!showAdminAuth">
        <button class="role-btn user-btn" @click="selectUser">
          <i class="fas fa-user"></i>
          <span>我是参与者</span>
        </button>
        <button class="role-btn admin-btn" @click="showAdminAuth = true">
          <i class="fas fa-user-shield"></i>
          <span>我是管理员</span>
        </button>
      </div>

      <!-- Admin Authentication -->
      <div v-else class="admin-auth">
        <div class="input-group">
          <input 
            type="password" 
            v-model="adminPassword"
            placeholder="请输入管理员密码"
            class="password-input"
            @keyup.enter="verifyAdmin"
          >
          <div class="error-message" v-if="showError">密码错误</div>
        </div>
        <div class="auth-buttons">
          <button class="auth-btn confirm-btn" @click="verifyAdmin">确认</button>
          <button class="auth-btn back-btn" @click="showAdminAuth = false">返回</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RoleSelectView',
  data() {
    return {
      showAdminAuth: false,
      adminPassword: '',
      showError: false
    }
  },
  methods: {
    selectUser() {
      localStorage.setItem('quizUserRole', 'user');
      this.$router.push('/quiz')
    },
    verifyAdmin() {
      if (this.adminPassword === '666666') {
        this.showError = false;
        localStorage.setItem('quizUserRole', 'admin');
        this.$router.push('/admin')
      } else {
        this.showError = true;
        this.adminPassword = ''
      }
    }
  }
}
</script>

<style scoped>
.role-select-container {
  min-height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.role-card {
  background: white;
  border-radius: 20px;
  padding: 40px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
  text-align: center;
}

.title {
  color: #2d3748;
  font-size: 28px;
  margin-bottom: 40px;
  font-weight: 600;
}

.role-buttons {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.role-btn {
  padding: 20px;
  border: none;
  border-radius: 12px;
  font-size: 18px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  color: white;
}

.user-btn {
  background: linear-gradient(to right, #4facfe 0%, #00f2fe 100%);
}

.admin-btn {
  background: linear-gradient(to right, #fa709a 0%, #fee140 100%);
}

.role-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 15px rgba(0, 0, 0, 0.1);
}

.role-btn:active {
  transform: translateY(0);
}

.admin-auth {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.password-input {
  padding: 15px;
  border: 2px solid #e2e8f0;
  border-radius: 10px;
  font-size: 16px;
  outline: none;
  transition: border-color 0.3s;
  width: 100%;
}

.password-input:focus {
  border-color: #4299e1;
}

.error-message {
  color: #e53e3e;
  font-size: 14px;
  margin-top: 5px;
}

.auth-buttons {
  display: flex;
  gap: 12px;
}

.auth-btn {
  flex: 1;
  padding: 12px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
}

.confirm-btn {
  background-color: #4299e1;
  color: white;
}

.back-btn {
  background-color: #e2e8f0;
  color: #4a5568;
}

.auth-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
}

.auth-btn:active {
  transform: translateY(0);
}
</style> 